import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

// `loginState` is merged into the state the login page receives, for routes
// that need it to explain why it is asking. The check-in page uses it: someone
// arriving from a printed QR did not choose to sign in, and a bare login form
// reads as the wrong page rather than a step.
export default function PrivateRoute({ children, loginState }) {
    const { isAuthenticated, isLoadingUser } = useAuth();
    const location = useLocation();

    if (isLoadingUser) {
        return <div>Loading...</div>; // Or a spinner component
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" state={{ from: location, ...loginState }} replace />;
    }

    return children;
}
